/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Tenant contact information
 */
export interface TenantContactDb {
  supportEmail?: string;
}
